export default __webpack_public_path__ + "static/media/maruti.e4545a1e.jpeg";